import { Auth } from "@/services/firebase/auth"
import { DB } from "@/services/firebase/db"
import Tracking from "@/types/tracking/tracking"
import firebase from "firebase/compat"
import { DateAndTimeHelper } from "@/helpers/DateAndTimeHelper"
import DateDialog from "@/components/DateAndTime/DateDialog.vue"

export class TrackingService {
  private dateTimeHelper;

  constructor () {
    this.dateTimeHelper = new DateAndTimeHelper()
  }

  startTime () {
    const roundedTime = this.dateTimeHelper.getRoundedDateTimeToLess()
    return DB.collection('trackings').doc().set({
      startingTime: roundedTime,
      userId: Auth.currentUser?.uid
    })
  }

  endTime (trackingId: string, endTime: number) {
    return DB.collection('trackings').doc(trackingId).set({
      endTime: endTime
    }, { merge: true })
  }

  updateTask (docId: string, task?: string) {
    if (task === undefined) {
      return DB.collection('trackings').doc(docId).update({
        task: firebase.firestore.FieldValue.delete()
      })
    } else {
      return DB.collection('trackings').doc(docId).set({
        userId: Auth.currentUser?.uid,
        task: task
      }, { merge: true })
    }
  }

  updateProject (docId: string, projectId?: string) {
    if (projectId === undefined) {
      return DB.collection('trackings').doc(docId).update({
        projectId: firebase.firestore.FieldValue.delete()
      })
    } else {
      return DB.collection('trackings').doc(docId).set({
        userId: Auth.currentUser?.uid,
        projectId: projectId
      }, { merge: true })
    }
  }

  updateDateTime (docId: string, dateTime: number) {
    return DB.collection('trackings').doc(docId).set({
      startingTime: dateTime,
      userId: Auth.currentUser?.uid
    }, { merge: true })
  }

  updateEndingDateTime (docId: string, dateTime: number) {
    return DB.collection('trackings').doc(docId).set({
      endTime: dateTime,
      userId: Auth.currentUser?.uid
    }, { merge: true })
  }

  startTimeWithProject (projectId: string) {
    const roundedTime = this.dateTimeHelper.getRoundedDateTimeToLess()
    return DB.collection('trackings').doc().set({
      startingTime: roundedTime,
      projectId: projectId,
      userId: Auth.currentUser?.uid
    })
  }

  fetchCurrentTracking () {
    return DB.collection('trackings').where('userId', '==', Auth.currentUser?.uid).get()
      .then((query) => {
        const trackingData = query.docs.map((doc) => {
          if (doc.exists) {
            return new Tracking({
              ...doc.data(),
              id: doc.id
            })
          }
        })
        if (trackingData.length < 1) {
          return null
        }
        return trackingData[0]
      })
  }

  removeCurrentTracking (trackingId: string) {
    return DB.collection('trackings').doc(trackingId).delete()
  }
}
